(() => {
  'use strict';
  const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  const compactMonths=window.matchMedia('(max-width: 420px)');
  function updateMonthLabels(root=document){root.querySelectorAll('.celestial-date-grid .celestial-select:first-child option').forEach(item=>{if(item.value){const month=months[Number(item.value)-1];const fullWidth=!!item.closest('[data-birth-form],[data-b3-form],[data-moon-form]');item.textContent=compactMonths.matches&&!fullWidth?month.slice(0,3):month;item.setAttribute('aria-label',month);}});}
  compactMonths.addEventListener('change',()=>updateMonthLabels());
  const pad = number => String(number).padStart(2, '0');
  const isoDate = value => {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
    if (!match) return false;
    const year = Number(match[1]), month = Number(match[2]), day = Number(match[3]);
    return month >= 1 && month <= 12 && day >= 1 && day <= new Date(Date.UTC(year, month, 0)).getUTCDate();
  };
  const option = (value, label) => new Option(label, value);
  const makeSelect = (label, values) => {
    const select = document.createElement('select');
    select.className = 'celestial-select';
    select.setAttribute('aria-label', label);
    select.append(option('', label));
    values.forEach(([value, text]) => select.append(option(value, text)));
    return select;
  };
  const syncPickers = target => target?.nextElementSibling?.matches('.celestial-picker') && target.nextElementSibling.dispatchEvent(new Event('celestial-sync'));

  function enhance(target) {
    if (target.dataset.celestialEnhanced || !target.closest('#MainContent')) return;
    const kind = target.type;
    if (kind !== 'date' && kind !== 'time') return;
    const wasRequired = target.required;
    const resetValue = target.defaultValue;
    const wrapper = document.createElement('span');
    wrapper.className = `celestial-picker celestial-${kind}-grid`;
    wrapper.setAttribute('role', 'group');
    wrapper.setAttribute('aria-label', kind === 'date' ? 'Choose a date' : 'Choose a time');
    const yearNow = new Date().getFullYear();
    const maxYear = Number(target.max?.slice(0, 4)) || yearNow;
    const years = Array.from({ length: Math.max(0, maxYear - 1900 + 1) }, (_, i) => [String(maxYear - i), String(maxYear - i)]);
    const selects = kind === 'date' ? [
      makeSelect('Month', months.map((month, i) => [pad(i + 1), month])),
      makeSelect('Day', Array.from({ length: 31 }, (_, i) => [pad(i + 1), pad(i + 1)])),
      makeSelect('Year', years)
    ] : [
      makeSelect('Hour', Array.from({ length: 24 }, (_, i) => [pad(i), pad(i)])),
      makeSelect('Minute', Array.from({ length: 60 }, (_, i) => [pad(i), pad(i)]))
    ];
    target.insertAdjacentElement('afterend', wrapper);
    target.type = 'hidden';
    target.dataset.celestialEnhanced = kind;
    target.removeAttribute('required');
    if (wasRequired) target.dataset.celestialRequired = 'true';
    if (kind === 'time') {
      wrapper.append(selects[0], Object.assign(document.createElement('span'), { className: 'celestial-time-separator', textContent: ':' }), selects[1]);
    } else {wrapper.append(...selects);updateMonthLabels(wrapper.parentElement);}
    if (target.id) {
      selects[0].id = `${target.id}-segment`;
      document.querySelectorAll('label[for]').forEach(label => {
        if (label.htmlFor === target.id) label.htmlFor = selects[0].id;
      });
    }
    let committing = false;

    function reflect() {
      const value = target.value;
      if (kind === 'date') {
        const pieces = isoDate(value) ? value.split('-') : ['', '', ''];
        [selects[0].value, selects[1].value, selects[2].value] = [pieces[1], pieces[2], pieces[0]];
      } else {
        const pieces = /^([01]\d|2[0-3]):[0-5]\d$/.test(value) ? value.split(':') : ['', ''];
        [selects[0].value, selects[1].value] = pieces;
      }
      updateDays();
      updateRequired();
    }
    function updateDays() {
      if (kind !== 'date') return;
      const month = Number(selects[0].value), year = Number(selects[2].value);
      const days = month ? new Date(Date.UTC(year || 2000, month, 0)).getUTCDate() : 31;
      [...selects[1].options].forEach(o => { if (o.value) o.disabled = Number(o.value) > days; });
      if (Number(selects[1].value) > days) selects[1].value = '';
    }
    function updateRequired() {
      const required = !target.disabled && (target.dataset.celestialRequired === 'true' || selects.some(select => select.value));
      selects.forEach(select => { select.required = required; select.disabled = target.disabled; });
      wrapper.hidden = target.disabled;
    }
    function commit() {
      updateDays();
      const full = selects.every(select => select.value);
      const value = kind === 'date' ? `${selects[2].value}-${selects[0].value}-${selects[1].value}` : `${selects[0].value}:${selects[1].value}`;
      const valid = full && (kind === 'time' || isoDate(value)) && (kind === 'time' || ((!target.min || value >= target.min) && (!target.max || value <= target.max)));
      target.value = valid ? value : '';
      updateRequired();
      if (full && !valid) selects[selects.length - 1].setCustomValidity('Choose a valid date within the allowed range.');
      else selects.forEach(select => select.setCustomValidity(''));
      committing = true;
      target.dispatchEvent(new Event('input', { bubbles: true }));
      target.dispatchEvent(new Event('change', { bubbles: true }));
      committing = false;
    }
    selects.forEach(select => select.addEventListener('change', commit));
    wrapper.addEventListener('celestial-sync', reflect);
    target.addEventListener('change', () => { if (!committing) reflect(); });
    target.addEventListener('input', () => { if (!committing) reflect(); });
    target.form?.addEventListener('reset', () => setTimeout(() => { target.value = resetValue; reflect(); }, 0));
    new MutationObserver(() => { updateRequired(); if (kind === 'date') commitMax(); }).observe(target, { attributes: true, attributeFilter: ['disabled', 'required', 'max'] });
    function commitMax() {
      const value = target.value;
      if (value && target.max && value > target.max) selects[2].setCustomValidity('Choose a date within the allowed range.');
      else selects[2].setCustomValidity('');
    }
    reflect();
  }

  function scan(root) {
    if (root.nodeType !== 1) return;
    if (root.matches?.('input[data-celestial-picker], #MainContent input[type="date"], #MainContent input[type="time"]')) enhance(root);
    root.querySelectorAll?.('input[data-celestial-picker], #MainContent input[type="date"], #MainContent input[type="time"]').forEach(enhance);
  }
  function start() {
    const main = document.getElementById('MainContent');
    if (!main) return;
    scan(main);
    new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(scan))).observe(main, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  window.CelestialDatePicker = { syncFromTarget: syncPickers };
})();
